import axios from "axios";
import Cookies from "js-cookie";
import { AUTH_CRED, getAuthCredentials, setAuthCredentials } from "../utils/auth-utils";
import { userClient } from "./user";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS, OPEN_API } from "./api-endpoints";
import { ERROR_MESSAGES } from "../utils/constants";

const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json, text/plain',
  },
});
// Change request data/error
const AUTH_TOKEN_KEY = process.env.REACT_APP_AUTH_TOKEN_KEY ?? AUTH_CRED;
Axios.interceptors.request.use((config: any) => {
  // If an explicit URL token is provided (e.g. from ?token= query param), use it directly
  if (config._urlToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${config._urlToken}`,
    };
    return config;
  }

  const cookies = Cookies.get(AUTH_TOKEN_KEY);
  let token = '';
  if (cookies) {
    token = JSON.parse(cookies)['token'];
  }

  // @ts-ignore
  if (OPEN_API.includes(config.url) ) {
    config.headers = {
      ...config.headers,
    // Authorization: `Bearer ${token}`,
    };
  } else {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  return config;
});

// Change response data/error here
Axios.interceptors.response.use(
  (response: any) => response,
  async (error: any) => {
    if (error?.response?.status === 500) {
      error.message = ERROR_MESSAGES.GENERIC_RETRY;
    }
    const originalRequest = error.config;
    const {token, refreshToken, customerUuid, details, userUuid, countryCode, isInternational} = getAuthCredentials();
    if (error?.response?.status === 401 && error?.response?.data?.message === 'Unauthorized' && !originalRequest._retry) {
      originalRequest._retry = true;
      if (refreshToken) {
        try {
          const response  = await userClient.refreshToken({ refreshToken: refreshToken }, {
            headers: { 'Authorization': `Bearer ${refreshToken}` }
          });
          if (response.success) {
            setAuthCredentials(response.data.access_token, response.data.refresh_token, customerUuid, userUuid, details, countryCode, 
              isInternational);
            originalRequest.headers['Authorization'] = `Bearer ${response.data.access_token}`;
            return Axios(originalRequest);
          } else {
            // const navigate = useNavigate();
            // navigate("/login");
            Cookies.remove(AUTH_TOKEN_KEY);
            window.location.reload();
          }
        } catch (refreshError) {
          console.log('error', refreshError)
          return Promise.reject(error);
        }
      } 
      // else {
      //   if (!token) {
      //     const request = {
      //       username: process.env.REACT_APP_AUTH_SYSTEM_KEY ?? '',
      //       password: process.env.REACT_APP_AUTH_SYSTEM_PASSWORD ?? '',
      //       userTypeId: 5
      //     };
      //     try {
      //       const response = await userClient.initiateLogin(request);
      //       if (response?.success) {
      //         setAuthCredentials(response?.data.access_token,response?.data.refresh_token);
      //         originalRequest.headers['Authorization'] = `Bearer ${response.data.access_token}`;
      //         return Axios(originalRequest);

      //       } else {
      //         // toast.error(response.error);
      //       }
      //     } catch (error: any) {
      //       console.error('Login API error:', error);
      //       return Promise.reject(error);
      //     }
      //   }
      // }
    }
    // if ((error.response && error.response.status === 403) ||
    //   (error.response &&
    //     error.response.data.message === 'NOT_AUTHORIZED')
    // ) {
    //   // Cookies.remove(AUTH_TOKEN_KEY);
    //   // window.location.reload();
    // }
    return Promise.reject(error);
  }
);

export class HttpClient {
  static async get<T>(url: string, params?: unknown) {
    const response = await Axios.get<T>(url, { params });
    return response.data;
  }

  static async post<T>(url: string, data: unknown, options?: any) {
    const response = await Axios.post<T>(url, data, options);
    return response.data;
  }

  static async put<T>(url: string, data: unknown) {
    const response = await Axios.put<T>(url, data);
    return response.data;
  }

  static async delete<T>(url: string) {
    const response = await Axios.delete<T>(url);
    return response.data;
  }
}

export const http = new HttpClient();

export function getFormErrors(error: any) {
  if (axios.isAxiosError(error)) {
    return error.response?.data.message;
  }
  return null;
}

export function getFieldErrors(error: any) {
  if (axios.isAxiosError(error)) {
    return error.response?.data.errors;
  }
  return null;
}
